import { render, staticRenderFns } from "./avalonMenuFonts.vue?vue&type=template&id=1e169062&scoped=true&"
import script from "./avalonMenuFonts.vue?vue&type=script&lang=js&"
export * from "./avalonMenuFonts.vue?vue&type=script&lang=js&"
import style0 from "./avalonMenuFonts.vue?vue&type=style&index=0&id=1e169062&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e169062",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDivider,VHover,VIcon,VSheet})
